import { render, staticRenderFns } from "./remindImmaturityList.vue?vue&type=template&id=4cbe8e8b&scoped=true&"
import script from "./remindImmaturityList.vue?vue&type=script&lang=js&"
export * from "./remindImmaturityList.vue?vue&type=script&lang=js&"
import style0 from "./remindImmaturityList.vue?vue&type=style&index=0&id=4cbe8e8b&prod&scoped=true&lang=css&"
import style1 from "./remindImmaturityList.vue?vue&type=style&index=1&id=4cbe8e8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbe8e8b",
  null
  
)

export default component.exports